import React from 'react';

import './styles.scss';

export default function NoMatch() {
    // eslint-disable-next-line no-console
    console.log("I never configured this route :(");
    return <h2 className="no-match">No Match (404)</h2>;
}